import { FRAGMENT_PAGINATOR } from '@marketplace/graphql/fragments/account.js'
import gql from 'graphql-tag'

export const PUBLICATION_CREATE = gql`
    mutation publicationCreate($input: PublicationCreateInput!) {
        publicationCreate(input: $input) {
            success
            userErrors {
                message
                name
            }
        }
    }
`

export const CREATE_PUBLICATION_VARIANT = gql`
    mutation createPublicationVariant($input: CreatePublicationVariantInput!) {
        createPublicationVariant(input: $input) {
            success
            userErrors {
                message
                name
            }
        }
    }
`

export const PUBLICATION_DELETE = gql`
    mutation publicationDelete($input: PublicationDeleteInput!) {
        publicationDelete(input: $input) {
            success
        }
    }
`

export const PUBLICATION_RESYNC = gql`
    mutation publicationResync($input: PublicationResyncInput!) {
        publicationResync(input: $input) {
            success
        }
    }
`

export const PUBLICATIONS_MASS_RESYNC = gql`
    mutation publicationMassResync($input: PublicationMassResyncInput!) {
        publicationMassResync(input: $input) {
            success
            userErrors {
                message
                name
            }
        }
    }
`

export const PUBLICATIONS_MASS_DELETE = gql`
    mutation publicationMassDelete($input: PublicationMassDeleteInput!) {
        publicationMassDelete(input: $input) {
            success
            userErrors {
                message
                name
            }
        }
    }
`

export const DISABLE_PUBLICATION_VARIANT = gql`
    mutation disablePublicationVariant(
        $input: DisablePublicationVariantInput!
    ) {
        disablePublicationVariant(input: $input) {
            success
        }
    }
`

export const SUBSCRIBE = gql`
    mutation retailerDropshippingSubscribe(
        $input: RetailerDropshippingSubscribeInput!
    ) {
        retailerDropshippingSubscribe(input: $input) {
            url
        }
    }
`

export const CANCEL = gql`
    mutation retailerDropshippingCancel {
        retailerDropshippingCancel {
            success
        }
    }
`

export const RESUME = gql`
    mutation RetailerDropshippingResume {
        RetailerDropshippingResume {
            success
        }
    }
`

export const UPDATE = gql`
    mutation retailerDropshippingUpdatePaymentMethod {
        retailerDropshippingUpdatePaymentMethod {
            url
            userErrors {
                message
                name
            }
        }
    }
`

export const PAY_OPEN_INVOICE = gql`
    mutation payOpenCashierInvoice($input: PayOpenCashierInvoiceInput!) {
        payOpenCashierInvoice(input: $input) {
            url
            message
            userErrors {
                message
                name
            }
        }
    }
`

export const UPGRADE_SUBSCRIPTION = gql`
    mutation retailerDropshippingSwapPlan(
        $input: RetailerDropshippingSwapPlanInput!
    ) {
        retailerDropshippingSwapPlan(input: $input) {
            success
            clientMutationId
            userErrors {
                message
                field
            }
        }
    }
`

export const GET_STOREFRONTS = gql`
    ${FRAGMENT_PAGINATOR}
    query getStorefronts(
        $first: Int!
        $page: Int
        $sort: String
        $query: String
    ) {
        viewer {
            account {
                retailerDropshippingStorefronts(
                    first: $first
                    page: $page
                    sort: $sort
                    query: $query
                ) {
                    paginator {
                        ...FragmentPaginator
                    }

                    results {
                        status
                        importedPublicationsCount
                        storefront {
                            id
                            databaseId
                            name
                            slug
                            avatar: storyImage {
                                transformedUrl(
                                    width: 80
                                    height: 80
                                    method: CROP
                                )
                            }
                        }
                    }
                }
            }
        }
    }
`

export const INGESTED_ORDER_CREATE_MUTATION = gql`
    mutation ingestedOrderCreate($input: IngestedOrderCreateInput!) {
        ingestedOrderCreate(input: $input) {
            ingestedOrder {
                id
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const SUBSCRIPTION_PAYMENT_STATUS = gql`
    mutation dropshippingSubscriptionPaymentStatus {
        dropshippingSubscriptionPaymentStatus {
            status
            redirectUrl
        }
    }
`

export const SUBSCRIPTION_PAYMENT_PAID = gql`
    mutation dropshippingSubscriptionPaymentPaid {
        dropshippingSubscriptionPaymentPaid {
            redirectUrl
            userErrors {
                field
                message
            }
        }
    }
`

export const GET_INVOICES = gql`
    query getInvoices($first: Int!, $page: Int) {
        viewer {
            account {
                dropshipping {
                    status
                    skuLimit
                    skuCount
                    brandLimit
                    brandCount
                    invoices(first: $first, page: $page) {
                        totalCount
                        results {
                            number
                            createdAt
                            total
                            url
                            status
                        }
                    }
                }
            }
        }
    }
`

export const GET_PLANS = gql`
    query getPlans {
        viewer {
            account {
                dropshippingInvitedByStorefront {
                    id
                    name
                }
            }
            plans {
                slug
                name
                description
                amount
                discountedAmount
                originalAnnualAmount
                processingFee
                interval
                duration
                availableCoupon {
                    slug
                    amount
                    percentage
                    times
                }
                features {
                    slug
                    name
                    description
                    tooltip
                    isAvailable
                }
            }
        }
    }
`

export const RETAILER_DROPSHIPPING_ACTIVATE = gql`
    mutation retailerDropshippingActivate(
        $input: RetailerDropshippingActivateInput!
    ) {
        retailerDropshippingActivate(input: $input) {
            account {
                dropshipping {
                    status
                }
            }
            userErrors {
                field
                message
            }
        }
    }
`
